import type { UserActivationApi } from '@hibro/shared';
import { createContext, useContext } from 'react';

export const unavailableUserActivation: UserActivationApi = {
  openBrowser: () =>
    Promise.reject(
      new Error('User-activated browser opening is unavailable in this host'),
    ),
};

export const UserActivationContext = createContext<UserActivationApi>(
  unavailableUserActivation,
);

export function useUserActivation(): UserActivationApi {
  return useContext(UserActivationContext);
}
